/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/*
    Hello there! This is a demonstration of how to override a file from the base template.

    It's necessary that the module export interface remain consistent,
    as other files in the base template rely on constants.js, thus we
    import the underlying constants.js, modifies it and re-export it.
*/

import {
    DEFAULT_LIMIT_VALUES,
    DEFAULT_SEARCH_PARAMS
} from '@salesforce/retail-react-app/app/constants'
import {defineMessage} from 'react-intl'

// original value is 25
DEFAULT_LIMIT_VALUES[0] = 3
DEFAULT_SEARCH_PARAMS.limit = 3

export const CUSTOM_HOME_TITLE = '🎉 Hello Extensible React Template!'

export {DEFAULT_LIMIT_VALUES, DEFAULT_SEARCH_PARAMS}

export const RESET_SUCCESS_TITLE = defineMessage({
    defaultMessage: 'Your password was successfully updated.',
    id: 'auth_modal.success.reset_password.title'
})
export const RESET_SUCCESS_DESCRIPTION = defineMessage({
    defaultMessage: 'You can now login and continue.',
    id: 'auth_modal.success.reset_password.description'
})
/* add to cart toast constants */
export const ADD_TO_CART_TOAST_DURATION = 3000

/* select role constants */
export const SELECTED_ROLE_KEY = 'selected-role'
export const ROLE_RIDER = 'rider'
export const ROLE_VET = 'vet'
export const PRODUCT_IDS_RIDER = [
    'F5700000Set',
    'F5700000',
    'F5700001',
    'F5700002',
    'F5700003',
    'F5700004',
    'F5700005',
    'F5700006'
]
export const PRODUCT_IDS_VET = ['F5700000Package', 'F_CONSTEED_OPT_08', 'F_CONSTEED_OPT_09']
export const CONSTEED_MASTER_PRODUCT_ID = 'F5700000BASE'
export const PRODUCT_VARIATION_VALUE_PACKAGE = 'package'
export const PRODUCT_VARIATION_VALUE_KIT = '4 shoes'
export const PRODUCT_INFORMATION_ACCORDION_LIMIT = 10

/* 3D Model constants */
export const MODEL_3D_CONFIG_FILE_URL = '/360/final/Consteed_360_Hufschuh_220824_final.xml'
export const MODEL_3D_GRAPHICS_PATH = 'static/webRotator/graphics'
export const MODEL_3D_ROOT_PATH = 'static/webRotator/final/'
export const MODEL_3D_ALT = defineMessage({
    defaultMessage: '360 degree view - Consteed_360',
    id: 'model_3d.alt.fallback'
})
export const MODEL_3D_RESPONSIVE_BASE_WIDTH = 800 // base width should in most cased get defind by container, could be 2000 for full width, 1440 for default container, 800 for text + 3D model
export const MODEL_3D_RESPONSIVE_MIN_HEIGHT = 300
export const MODEL_3D_LICENSE_CODE =
    'BjGZmexZTiM8SQN0Wyokd1vJAXI1wixqydGf3O/RlW5JbW8uhWWWnM+gujiKvqhQb6SSgHRzFZlfDb8fnJqU8Z5aDMETAJG1lQZNUsXp'

/* App Store links */
export const APP_STORE_LINK_IOS = 'https://apps.apple.com/us/app/consteed/id1663875464'
export const APP_STORE_LINK_ANDROID =
    'https://play.google.com/store/apps/details?id=com.continental.consteed&pli=1'

/* Social Media */
export const SOCIAL_MEDIA_INSTAGRAM = 'https://www.instagram.com/continental_consteed/'
export const SOCIAL_MEDIA_FACEBOOK = '' // deactivated

/* legal links */
export const LEGAL_PRIVACY_POLICY_PATH = '/page-viewer/Privacypolicy'
export const LEGAL_TERMS_CONDITIONS_PATH = '/page-viewer/termsandconditions'

/* withdrawal (Widerruf) shopper custom API */
export const WITHDRAWAL_HOOK_API_NAME = 'withdrawal'
export const WITHDRAWAL_HOOK_API_VERSION = 'v1'
export const WITHDRAWAL_HOOK_RESOURCE = 'send'
export const WITHDRAWAL_HOOK_SCOPE = 'c_withdrawal_rw'

export * from '@salesforce/retail-react-app/app/constants'
